import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { BillingLetter } from '../../../models/billing-letter/BillingLetter.model';
import { BillingLetterService } from '../../../services/billing-letter/billing-letter.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Owner } from '../../../models/billing-letter/Owner.model';
import { Company } from '../../../models/billing-letter/Company.model';
import { AccountingPeriodBlock } from "../../../models/AccountingPeriodBlock.model";
import { AccountingPeriodBlockService } from "../../../services/accountingBlock.service";
import { Parcel } from '../../../models/billing-letter/Parcel.model';
import { CompanyService } from '../../../services/billing-letter/company.service';
import { RefundsService } from '../../../services/refund.service';
import { CnaeService } from '../../../services/cnae.service';
import { OwnerService } from '../../../services/billing-letter/owner.service';
import { NatureProvider } from '../../../shared/providers/enums/nature.provider';
import { ValueClassProvider } from '../../../shared/providers/enums/value-class.provider';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { ProductService } from '../../../services/product.service';
import { Contact } from '../../../models/billing-letter/Contact.model';
import { Toast, ToastsManager } from 'ng2-toastr';
import * as moment from 'moment';
import * as _ from 'lodash';
import { GUARDS } from '../../../shared/auth/Roles';
import { StatusProvider } from "../../../shared/providers/enums/billing-letter/status-provider";
import { CompetenceProvider } from "../../../shared/providers/enums/billing-letter/competence-provider";
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { ProjectFinancial } from '../../../models/project/ProjectFinancial.model';
import { CompanyGroup } from "../../../models/billing-letter/CompanyGroup.model";
import { ProductFinancial } from '../../../models/project/ProductFinancial.model';
import { Product } from "../../../models/billing-letter/Product.model";
import { RefundBilling } from '../../../models/billing-letter/Refund.model';
import { SapItemType } from '../../../shared/enums/SapItemType';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { AutoIncrement } from "../../../shared/helpers/auto-increment";
import { BillingParcelService } from '../../../services/billing-letter/billing-parcel.service';
import { AccountingType } from '../../../shared/enums/AccountingBlockType';
import { ProductType } from '../../../shared/enums/billing-letter/productType';

@Component({
    selector: 'app-billing-letter-edit',
    templateUrl: './billing-letter-edit.component.html',
    styleUrls: ['./billing-letter-edit.component.scss']
})
export class BillingLetterEditComponent implements OnInit {
    @ViewChild("buttonclosemodal") buttonclosemodal: ElementRef;
    @ViewChild("buttonOpenModalParcel") buttonOpenModalParcel: ElementRef;

    //Scroll automatico até a parcela especificada na URL
    @ViewChild('boxParcels') set content(content: ElementRef) {
        if(!this.redirected){
            if (content) {
                if(this.parcelIdModal) {
                    this.redirected = true;
                    let parcelsElements = content.nativeElement.children;
                    if(parcelsElements[this.indexParcelModal ? this.indexParcelModal : 0])
                        parcelsElements[this.indexParcelModal ? this.indexParcelModal : 0].scrollIntoView({block: 'center'});
                }
            }
        }
    }
    users: Owner[] = [];
    companies: Company[] = [];
    companyGroups: CompanyGroup[] = [];
    projects : ProjectFinancial[];

    products: Product[];
    contractTypes: any[] = [];
    productType: number = 0;
    refunds: RefundBilling[];
    projectsByCompany = [];
    nextParcelConfiguration: Parcel;
    recurrence = 1;
    isRecurrence: boolean = false;
    datePickerOptions = this.commonHelper.getDatePickerOptions();
    id;

    valueClasses = this.valueClassProvider.valueClasses;
    statuses = this.statusesProvider.statuses;
    natures = this.natureProvider.natures;
    competence = this.commonHelper.listAllMonths();
    competences = this.competenceProvider.competences;
    competenceYear = this.commonHelper.listLastYears();

    billingLetter: BillingLetter = new BillingLetter();
    currentStep = 'parcels';

    GUARDS = GUARDS;
    canSave: Boolean = true;
    allowedRoles = [GUARDS.MANAGER, GUARDS.GOVERNANCE, GUARDS.FINANCES, GUARDS.BILLSRECEIVE];
    user;

    loading;
    validParcels: Boolean = true;
    parcelIndexAddRefund: number = -1;
    refundsToUpdate = [];

    projectsDropdown = {
        list: [],
        options: null,
        selected: []
    };

    productsDropdown = {
        list: [],
        options: null,
        selected: []
    };
    companiesDropdown = {
        list: [],
        options: null,
        selected: []
    };
    refundsDropdown = {
        list: [],
        options: null,
        selected: []
    };

    parcelsNames: any[] = [];
    joinParcels: Array<{ name: string, parcels: Array<any>, blockJoinParcel: boolean }> = [];
    joinParcelsDropdown = {
        list: [],
        options: null,
        selected: []
    };

    cnaes;
    companyAux = { id: '', itemName: ''};
    typeOrdering: Array<boolean> = [false, false, false, false];
    redirected: boolean = false;

    indexParcelModal: number;
    parcelIdModal: string;
    isCreate: boolean = false;

    months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    blockParcel: boolean = false;
    blockCompanyGroup: boolean = false;
    integratedParcelsRemoved = [];

    modalOpen: boolean = false;
    multiParcels: boolean = false;
    accountingBlock = new AccountingPeriodBlock();

    constructor(private billingLetterService: BillingLetterService,
        private billingParcelService: BillingParcelService,
        private companiesService: CompanyService,
        private ownerService: OwnerService,
        private valueClassProvider: ValueClassProvider,
        private statusesProvider: StatusProvider,
        private competenceProvider: CompetenceProvider,
        private natureProvider: NatureProvider,
        private projectFinancialService: ProjectFinancialService,
        private productService: ProductService,
        private commonHelper: CommonHelper,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private router: Router,
        private localStorage:LocalStorage,
        private dropDownItemFactory: DropdownItemFactory,
        private dropDownSettingFactory: DropdownSettingsFactory,
        private refundService: RefundsService,
        private cnaeService: CnaeService,
        private errorHandler: ErrorHandlerProvider,
        private accountingBlockService: AccountingPeriodBlockService,
        private newContractTypeEnum: ProductType) { }

    async ngOnInit() {
        this.loading = true;
        this.accountingBlock = (await this.accountingBlockService.getAllBlockedPeriods())
        .find(({type}: AccountingPeriodBlock) => type === AccountingType.BillingLetter);

        this.checkPermissions();

        this.projectsDropdown.options = this.dropDownSettingFactory.build({text:'Projetos'});
        this.productsDropdown.options = this.dropDownSettingFactory.build({text:'Produtos'});
        this.companiesDropdown.options = this.dropDownSettingFactory.build({text:'Clientes'});
        this.refundsDropdown.options = this.dropDownSettingFactory.build({text:'Reembolsos',singleSelection:true});
        this.joinParcelsDropdown.options = this.dropDownSettingFactory.build({ text: 'Junção de Parcelas' })

        this.loadNextParcel();
        this.users = await this.ownerService.getAll();

        let response = await this.billingLetterService.findOne(this.route.snapshot.params['id']);
        await this.billingLetter.populateFromServer((response).billingLetter);
        this.blockCompanyGroup = !!this.billingLetter.parcels.filter(parcel => parcel.sapDocEntry).length;
        this.checkCompetence();

        this.companyGroups = await this.companiesService.getAllCompanyGroups();
        this.companyGroups = _.orderBy(this.companyGroups,[companyGroup => companyGroup.name.toUpperCase()]);

        this.companies = await this.companiesService.getCompaniesByGroupId(this.billingLetter.companyGroup._id);
        this.companies = _.orderBy(this.companies,[company => company.name.toUpperCase()]);
        this.companies = _.filter(this.companies,item => item.active == true);
        this.companiesDropdown.list = this.dropDownItemFactory.build({source:this.companies});

        this.cnaes = await this.cnaeService.getAllItems([SapItemType.CnaeBilling]);

        this.projects = await this.projectFinancialService.getProjectByGroupId(this.billingLetter.companyGroup._id);
        this.projects = _.orderBy(this.projects,[project => project.name.toUpperCase()]);

        // this.products = await this.productService.getAllProducts();
        // this.products = _.orderBy(this.products,[product => product.name.toUpperCase()]);

        // this.populateContractTypes();

        this.refunds = await this.refundService.getRefundsByGroupId(this.billingLetter.companyGroup._id);
        this.refunds = this.refunds.filter(refund => !refund.associatedBillingLetter);
        this.refunds = this.refunds.map(refund => {
            refund.value = refund.valuePaidCustomer;
            refund.name = `ID: ${refund._id} / Valor pago pelo cliente: R$ ${refund.valuePaidCustomer} / Data: ${moment(refund.created).format("DD/MM/YYYY")} / Consultor: ${refund.consultant ? refund.consultant.name : ''}`;
            return refund;
        });

        this.projectsDropdown.list = this.dropDownItemFactory.build({source:this.projects});
        this.projectsDropdown.selected = this.dropDownItemFactory.build({source:this.billingLetter.projects});
        this.projectsDropdown.selected = this.projectsDropdown.selected.map(project => {
            const proj = this.projects.find(p => p._id === project.id);
            if(proj && proj.sapProjectId)
                project.sapProjectId = proj.sapProjectId;
            return project;
        })

        this.productsDropdown.list = this.dropDownItemFactory.build({source:this.products});
        this.productsDropdown.selected = this.dropDownItemFactory.build({source:this.billingLetter.products});

        this.refundsDropdown.list = this.dropDownItemFactory.build({source:this.refunds});
        this.refundsDropdown.selected = this.dropDownItemFactory.build({source:this.billingLetter.refunds});

        this.loadJoinParcels();

        if(this.accountingBlock && this.accountingBlock.competenceYear &&
           this.accountingBlock.competence){
            this.datePickerOptions.minDate = new Date(this.accountingBlock.competenceYear,this.accountingBlock.competence,1);
        }

        const [, parcelId] = String(this.route.snapshot.fragment).split('parcel-');
        const parcelIndex = this.billingLetter.parcels.findIndex(parcel => parcel._id === parcelId);
        this.parcelIdModal = parcelId;
        this.indexParcelModal = parcelIndex;

        this.nextParcelConfiguration.competence = 0;
        this.nextParcelConfiguration.competenceYear = 0;
        this.nextParcelConfiguration.status = 1;
        this.nextParcelConfiguration.value = 0;

        this.billingLetter.parcels.forEach((parcel, index) => {
            if (parcel.industry) return;
            if(parcel.company && parcel.company._id) {
                const parcelCompany = this.companies.find(({ _id }) => _id === parcel.company._id)
                this.billingLetter.parcels[index].industry = parcelCompany.industry
            }
        })

        this.loading = false;
    }

    ngOnDestroy() {
        if(this.modalOpen)
            this.buttonOpenModalParcel.nativeElement.click();
    }

    populateContractTypes() {
        this.contractTypes = [...this.newContractTypeEnum.contractTypes];
    }

    loadJoinParcels() {
        this.joinParcels = [];
        this.joinParcelsDropdown.list = [];
        this.joinParcelsDropdown.selected = [];

        this.parcelsNames = this.billingLetter.parcels
            .filter(parcel => parcel.parcelJoin)
            .map(parcelJoin => parcelJoin.parcelJoin)
            .filter((name, pos, a) => a.indexOf(name) == pos);

        this.parcelsNames.forEach((parcelName) => {
            let parcelIds = [];
            let blockJoinParcel = false;
            this.billingLetter.parcels.forEach((parcel, index) => {
                if (parcel.parcelJoin && parcel.parcelJoin == parcelName && parcel.status != 6) {
                    parcelIds.push({
                        id: String(index),
                        itemName: `Parcela #${index + 1}`,
                        parcelId: parcel._id,
                        status: parcel.status
                    });

                    if(parcel.status == 4 || parcel.status == 5 || parcel.status == 7)
                        blockJoinParcel = true;
                }
            })
            this.joinParcels.push({
                name: parcelName,
                parcels: [...parcelIds],
                blockJoinParcel
            });
            parcelIds = [];
        });

        this.billingLetter.parcels.forEach((parcel, index)=>{
            if(!parcel.parcelJoin && parcel.status < 4){
                this.joinParcelsDropdown.list.push({
                    id: String(index),
                    itemName: `Parcela #${index + 1}`,
                    parcelId: parcel._id,
                    status: parcel.status
                })
            }
        });

        let parcelsCanceledWithParcelJoin = [];

        this.billingLetter.parcels.forEach((parcel, index) => {
            if (parcel.status == 6 && parcel.parcelJoin)
                parcelsCanceledWithParcelJoin.push(index)
        });
    }

    joinParcelsDropdownFiltered() {
        return this.joinParcelsDropdown.list.filter(itemlist => itemlist.status != 6)
    }

    checkPermissions() {
        this.user = this.localStorage.retrieve('user');
        if(!this.allowedRoles.includes(this.user.permission)) {
            this.canSave = false;
        }
    }

    checkCompetence() {
        if(this.accountingBlock !== null) {
            let totalBlocking = Number(this.accountingBlock.competenceYear) + (Number(this.accountingBlock.competence) / 100);
            this.billingLetter.parcels = this.billingLetter.parcels.map(parcel => {
                if(parcel.status > 2) {
                    if(parcel.competenceYear && parcel.competence){
                        let totalParcel = parcel.competenceYear + (parcel.competence / 100);
                        if(totalParcel <= totalBlocking) {
                            parcel.canEdit = false;
                        } else {
                            parcel.canEdit = true;
                        }
                    }
                } else {
                    parcel.canEdit = true;
                }

                return parcel;
            });
        } else {
            this.billingLetter.parcels = this.billingLetter.parcels.map(parcel => {
                parcel.canEdit = true;
                return parcel;
            });
        }
    }

    checkParcel(parcel: Parcel): string {
        if(!parcel.canEdit || parcel.status >= 4 || parcel.issued) {
            return "disable";
        }

        return "activate";
    }

    statusDisabled(status:number){
        if(status < 4 && (this.user.permission == GUARDS.FINANCES || this.user.permission == GUARDS.BILLSRECEIVE)){
            return true;
        }else if(status > 3 && this.user.permission != GUARDS.FINANCES && this.user.permission != GUARDS.BILLSRECEIVE)
            return true;
        return false;
    }

    disabledParcel(parcel:Parcel){
        if(parcel.status == 6)
            return true;
        else if(parcel.status > 3 && this.user.permission != GUARDS.FINANCES && this.user.permission != GUARDS.BILLSRECEIVE)
            return true;
        return false;
    }

    async save() {
        try {
            this.ordering();
            this.removeHours();

            if(!this.parcelJoinValid()) {
                this.toastr.warning('Uma junção deve possuir um nome e parcelas associadas', 'Junção de Parcela inválida', {
                    toastLife: 8000,
                    showCloseButton: true
                });
                return;
            }

            let projects = this.projectsDropdown.selected.map(project => {
                return <ProjectFinancial>{_id:project.id,name:project.itemName,sapProjectId:project.sapProjectId}
            });
            let products = this.productsDropdown.selected.map(product => {
                return <ProductFinancial>{_id:product.id,name:product.itemName,sapItemCode:product.sapItemCode}
            });

            this.billingLetter.projects = projects;
            this.billingLetter.products = products;

            this.loading = true;
            let response = await this.billingLetterService.update(this.billingLetter, this.route.snapshot.params['id']);
            if(response.success){

                /* Condition for update refund with billingLetterId */
                if(this.refundsToUpdate.length > 0) {
                    for(let refundsUpdate of this.refundsToUpdate) {
                        refundsUpdate.updateBillingLetterId = true;
                        refundsUpdate.billingLetterId = response.data._id;
                        await this.refundService.update(refundsUpdate);
                    }
                }

                if (response.updatedOnSap) {
                    const { success, fail, notIntegrated } = response.updatedOnSap;
                    await this.toastr.info(
                        `Atualizações de parcelas realizadas:</br>
                        •Sucesso: ${success}</br>
                        •Falha: ${fail}</br>
                        •Não-integradas: ${notIntegrated}`,
                        'Carta de Faturamento',
                        {toastLife: 10000, enableHTML: true}
                    )
                }

                if(!this.blockParcel) {
                    this.loading = false;
                    await this.toastr.success('Carta editada com sucesso!');
                    await this.router.navigate(['/billing-letter']);
                } else {
                    let response = await this.billingLetterService.findOne(this.route.snapshot.params['id']);
                    this.billingLetter = new BillingLetter();
                    await this.billingLetter.populateFromServer((response).billingLetter);
                    this.loadJoinParcels();
                    this.blockParcel = false;
                    this.loading = false;
                    await this.toastr.success('Carta editada com sucesso!');
                }
            } else {
                this.loading = false;
                this.errorHandler.interceptError(response, "Carta de faturamento")
            }

        } catch (err) {
            this.loading = false;
            this.errorHandler.interceptError(err, "Carta de faturamento")
        }
    }

    addParcelFromLastOne() {
        this.loadNextParcel();
        this.addParcel();
    }

    async addParcel() {
        if (this.multiParcels)
            this.nextParcelConfiguration.status = 1;

        let res = await this.billingParcelService.create(this.nextParcelConfiguration);
        if(res._id)
            this.billingLetter.parcels.push(res);
        await this.loadNextParcel();
        this.updateJoinParcelDropdown(true);
        return res;
    }

    async loadNextParcel() {
        this.nextParcelConfiguration = await this.nextParcel();
    }

    calculateValueLiquid(index) {
        const parcel = this.billingLetter.parcels[index];
        let valueLiquid = parcel.value;
        if(!isNaN(parcel.iss)) valueLiquid -= parcel.iss;
        if(!isNaN(parcel.pis)) valueLiquid -= parcel.pis;
        if(!isNaN(parcel.irrf)) valueLiquid -= parcel.irrf;
        if(!isNaN(parcel.cofins)) valueLiquid -= parcel.cofins;
        if(!isNaN(parcel.discountGranted)) valueLiquid -= parcel.discountGranted;
        this.billingLetter.parcels[index].valueLiquid = valueLiquid;
        this.loadNextParcel();
    }

    async nextParcel() {
        if (this.billingLetter.parcels.length == 0)
            return new Parcel({
                project: this.projectsDropdown.selected.length > 0
                    ?  this.projectsDropdown.selected.map(item => ({ _id:item.id, name:item.itemName, value:0, sapProjectId: item.sapProjectId}))
                    : [],
                product: this.productsDropdown.selected.length > 0
                    ?  this.productsDropdown.selected.map(item => ({ _id:item.id, name:item.itemName, value:0, sapItemCode: item.sapItemCode}))
                    : [],
                refund: []
            });

        const lastParcel = await this.lastParcel();
        const nextMonth = Number(lastParcel.competence) + 1;
        const nextYear = Number(lastParcel.competenceYear);
        const monthYear = this.nextMonthYear(nextMonth, nextYear);

        const projects = this.projectsDropdown.selected.map((project) => ({
            _id:            project.id,
            name:           project.itemName,
            value:          0,
            sapProjectId:   project.sapProjectId
        }));

        const products = this.productsDropdown.selected.map((product) => ({
            _id:            product.id,
            name:           product.itemName,
            value:          0,
            sapItemCode:    product.sapItemCode
        }));

        const excellenceCenters = lastParcel.excellenceCenters.map((ec) => ({
            _id:            ec._id,
            name:           ec.name,
            value:          ec.value,
            sapCode:        ec.sapCode,
            percentage:        ec.percentage
        }));

        const supportCenters = lastParcel.supportCenters.map((ec) => ({
            _id:            ec._id,
            name:           ec.name,
            value:          ec.value,
            sapCode:        ec.sapCode,
            percentage:        ec.percentage
        }));

        const industry = this.getIndustry(lastParcel)
        if (industry) {
            industry.percentage = 100
        }

        const nextParcel = new Parcel({
            ...lastParcel,
            issued: false,
            issueDate: moment(lastParcel.issueDate).add(1, 'month'),
            dueDate: moment(lastParcel.dueDate).add(1, 'month'),
            paymentDate: moment(lastParcel.paymentDate).add(1, 'month'),
            created: moment(lastParcel.paymentDate).add(1, 'month'),
            observation: '',
            nf: '',
            competence: 0,
            competenceYear: 0,
            sapDocEntry: '',
            sapDocNum: '',
            integratedSap: false,
            parcelCanceled: false,
            canEdit: true,
            refund: [],
            project: this.projectsDropdown.selected.length > 0 ? projects : [],
            product: this.productsDropdown.selected.length > 0 ? products : [],
            industry: industry || {},
            excellenceCenters: lastParcel.excellenceCenters.length > 0 ? excellenceCenters : [],
            supportCenters: lastParcel.supportCenters.length > 0 ? supportCenters : [],
            status: 1,
            parcelJoin: '',
            accountingLoss: 0,
            accountingLossJustification: '',
            isAnticipation: false
    });

        return nextParcel;
    }

    nextMonthYear(month: number, year: number) {
        const currentMonth = this.months.indexOf(month)
        if (currentMonth === -1)
            return {
                month: this.months[0],
                year: year + 1
            }

        return {
            month: this.months[currentMonth],
            year: year
        }
    }

    async lastParcel() {
        let parcel = this.billingLetter.parcels[this.billingLetter.parcels.length - 1];
        let res = await this.billingParcelService.getByID(parcel._id);
        if(res._id) {
            return res;
        } else {
            return parcel;
        }
    }

    removeParcel(index) {
        const parcelRemoved = _.cloneDeep(this.billingLetter.parcels[index]);
        if(parcelRemoved.sapDocEntry) {
            this.integratedParcelsRemoved.push(parcelRemoved);
        }

        this.billingLetter.parcels.splice(index, 1);
        this.loadNextParcel();
        this.updateJoinParcelDropdown(false, index);
    }

    addContact() {
        this.billingLetter.contacts.push(new Contact());
    }

    removeContact(index) {
        this.billingLetter.contacts.splice(index, 1);
    }

    compare(val1, val2) {
        if (val1 && val2) {
            return val1._id === val2._id;
        } else
            return false;

    }

    validLetter() {
        if (_.isEmpty(this.billingLetter.name)
            || _.isEmpty(this.billingLetter.owner._id)
            || _.isEmpty(this.billingLetter.companyGroup._id)
            ||
            // (
                this.projectsDropdown.selected.length == 0
                // &&
                //  this.productsDropdown.selected.length == 0)
            // || this.billingLetter.productType == 0
            )
            // || _.isEmpty(this.billingLetter.company._id)
            // || this.projectsDropdown.selected.length == 0
            // || this.companiesDropdown.selected.length == 0)
            return false;

        return true;
    }

    async changeGroup() {
        this.companies = await this.companiesService.getCompaniesByGroupId(this.billingLetter.companyGroup._id);
        this.companies = _.orderBy(this.companies,[company => company.name.toUpperCase()]);
        this.companies = _.filter(this.companies,item => item.active == true);
        this.companiesDropdown.list = this.dropDownItemFactory.build({source:this.companies});

        this.projects = await this.projectFinancialService.getProjectByGroupId(this.billingLetter.companyGroup._id);
        this.projects = _.orderBy(this.projects,[project => project.name.toUpperCase()]);
        this.projectsDropdown.list = this.dropDownItemFactory.build({source:this.projects});

        this.refunds = await this.refundService.getRefundsByGroupId(this.billingLetter.companyGroup._id);
        this.refunds = this.refunds.filter(refund => !refund.associatedBillingLetter);
        this.refunds = this.refunds.map(refund => {
            refund.value = refund.valuePaidCustomer;
            refund.name = `ID: ${refund._id} / Valor pago pelo cliente: R$ ${refund.valuePaidCustomer} / Data: ${moment(refund.created).format("DD/MM/YYYY")} / Consultor: ${refund.consultant ? refund.consultant.name : ''}`;
            return refund;
        });
        this.refundsDropdown.list = this.dropDownItemFactory.build({source:this.refunds});
    }

    async changeCliente() {
        this.projects = await this.projectFinancialService.getProjectByGroupId(this.billingLetter.companyGroup._id)
        this.projects = _.orderBy(this.projects,[project => project.name.toUpperCase()]);
        this.projectsDropdown.list = this.dropDownItemFactory.build({source:this.projects});
    }

    removeHours() {
        this.billingLetter.parcels = this.billingLetter.parcels.map(parcel => {
            parcel.paymentDate = new Date(moment(parcel.paymentDate).subtract(3, 'hours').toString());
            parcel.dueDate = new Date(moment(parcel.dueDate).subtract(3, 'hours').toString());
            parcel.issueDate = new Date(moment(parcel.issueDate).subtract(3, 'hours').toString());
            return parcel;
        });
    }

    setParcelIndexToAddRefund(i) {
        this.parcelIndexAddRefund = parseInt(i);
    }

    clearAddRefund() {
        this.parcelIndexAddRefund = -1;
    }

    addRefund() {
        const i = this.parcelIndexAddRefund;
        const refundSelected = this.refundsDropdown.selected[0];

        if(i < 0 || !refundSelected) return;

        this.billingLetter.parcels[i].refund.push({
            _id: refundSelected.id,
            name: refundSelected.itemName,
            value: refundSelected.value
        });

        //refunds to update
        this.refundsToUpdate.push({
            _id: refundSelected.id,
            associatedBillingLetter: true,
            billingLetterId: ''
        });

        this.refundsDropdown.list = this.refundsDropdown.list.filter(refund => refund.id !== refundSelected.id);

        this.refundsDropdown.selected = [];
        this.clearAddRefund();
        this.buttonclosemodal.nativeElement.click();
    }

    removeRefund(parcelIndex, refundId) {
        let refundListAux = this.billingLetter.parcels[parcelIndex].refund;
        let refundAux = refundListAux.find(refund => refund._id === refundId);
        refundListAux = refundListAux.filter(refund => refund._id !== refundId);

        this.billingLetter.parcels[parcelIndex].refund = refundListAux;
        this.refundsDropdown.list.push({
            id: refundAux._id,
            itemName: refundAux.name,
            value: refundAux.value,
        });
        this.refundsToUpdate = this.refundsToUpdate.filter(refund => refund._id !== refundAux._id);
    }

    getValuePartial(parcel) {
        let sumProject = parcel.project.reduce((acc, { value }) => acc + value, 0);
        let sumProduct = parcel.product.reduce((acc, { value }) => acc + value, 0);
        let sumRefund = parcel.refund.reduce((acc, { value }) => acc + value, 0);
        return parcel.value - sumProduct - sumProject - sumRefund;
    }

    ordering(type?: number) {
        if(this.canSave) {
            switch (type) {
                case 0:
                    this.billingLetter.parcels.sort((a, b) => {
                        let aCompetence = a.competence ? a.competenceYear ?
                                moment(`1/${a.competence}/${a.competenceYear}`).valueOf()
                            :  a.competence : 0;
                        let bCompetence = b.competence ? b.competenceYear ?
                                moment(`1/${b.competence}/${b.competenceYear}`).valueOf()
                            :  b.competence : 0;

                        return this.orderSort(
                            this.typeOrdering[type],
                            aCompetence,
                            bCompetence,
                            true,
                            a.competenceYear ? a.competenceYear : 0,
                            b.competenceYear ? b.competenceYear : 0
                        );
                    });
                    break;
                case 1:
                    this.billingLetter.parcels.sort((a, b) =>
                        this.orderSort(
                            this.typeOrdering[type],
                            a.issueDate ? moment(a.issueDate).valueOf() : 0,
                            b.issueDate ? moment(b.issueDate).valueOf() : 0
                        )
                    );
                    break;
                case 2:
                    this.billingLetter.parcels.sort((a, b) =>
                        this.orderSort(
                            this.typeOrdering[type],
                            a.created ? moment(a.created).valueOf() : 0,
                            b.created ? moment(b.created).valueOf() : 0
                        )
                    );
                    break;
                case 3:
                    this.billingLetter.parcels.sort((a, b) =>
                        this.orderSort(
                            this.typeOrdering[type],
                            a.dueDate ? moment(a.dueDate).valueOf() : 0,
                            b.dueDate ? moment(b.dueDate).valueOf() : 0
                        )
                    );
                    break;
                default:
                    this.billingLetter.parcels.sort((a, b) =>
                        this.orderSort(
                            true,
                            a.competence ? a.competence : 0,
                            b.competence ? b.competence : 0
                        )
                    );
                    break;
            }
            if(type || type == 0) this.typeOrdering[type] = !this.typeOrdering[type];
        }
    }

    orderSort(type: boolean, a: number, b: number, isCompetence?: boolean, aCompetenceYear?: any, bCompetenceYear?: any) {
        if(type) {
            if(isCompetence)
                if(aCompetenceYear == 0 || bCompetenceYear == 0) return b - a;
            if(a == 0 || b == 0) return b - a;
            return a - b;
        } else return b - a;
    }

    changeBlockParcel() {
        this.blockParcel = true;
    }

    openParcelModal(index:number , id:string) {
        this.indexParcelModal = index;
        this.parcelIdModal = `${id}-${new Date().getTime()}`;
        this.isCreate = false;
        this.buttonOpenModalParcel.nativeElement.click();
        this.modalOpen = true;
    }

    createNewParcel() {
        let endParcel = this.billingLetter.parcels[this.billingLetter.parcels.length - 1];
        this.parcelIdModal = `${endParcel._id.toString()}-${new Date().getTime()}`;
        this.indexParcelModal = this.billingLetter.parcels.length;
        this.isCreate = true;
        this.buttonOpenModalParcel.nativeElement.click();
        this.modalOpen = true;
    }

    checkNavigationBlock(tab) {
        if(this.blockParcel) {
            this.toastr.info("Você fez alterações que modificam as parcelas. Antes de acessar a aba 'parcelas', é necessário salvar a carta de faturamento", "Carta de faturamento alterada", {
                toastLife: 5000,
                showCloseButton: true
            });
        } else {
            this.currentStep = tab;
        }
    }

    closeModal(parcelCreated: boolean) {
        this.modalOpen = false;
        this.multiParcels = false;
        this.isRecurrence = false;
        this.recurrence = 1;

        if(parcelCreated) {
            this.updateJoinParcelDropdown(true);
        }
    }

    parcelJoinValid() {
        for(let joinParcel of this.joinParcels) {
            if(!joinParcel.name || joinParcel.parcels.length == 0)
                return false;
        }
        return true;
    }

    addJoinParcels() {
        const lastJoinParcelSerie = this.getLastJoinParcelSerie();
        const joinParcelSerie = AutoIncrement((lastJoinParcelSerie + 1), '0')
        this.joinParcels.push({ name: joinParcelSerie, parcels: [], blockJoinParcel: false });
    }

    getLastJoinParcelSerie() {
        const allJoinParcels = this.joinParcels.map(joinParcel => joinParcel.name);
        if(allJoinParcels.length == 0)
            return 0;

        let serieNumbers = allJoinParcels.map(joinParcel => parseInt(joinParcel.replace('FAT', '')));
        serieNumbers.sort((a, b) => a - b);

        return serieNumbers[serieNumbers.length - 1];
    }

    removeJoinParcel(index, deselectItems){
        let removeJoinParcel = true;
        for (const item of deselectItems) {
            const parcelIndex = this.billingLetter.parcels.findIndex(parcel => parcel._id == item.parcelId);
            const statusParcel = this.billingLetter.parcels[parcelIndex].status;

            if (statusParcel == 4 || statusParcel == 5 || statusParcel == 7) {
                removeJoinParcel = false
                return this.toastr.warning(`Uma ou mais parcelas nessa junção possui(em) status "Pagamento Pendente", "Pago" ou "Perda Contabil"`);
            }

            this.onJoinParcelUnselect(item);
        }

        if(removeJoinParcel)
            this.joinParcels.splice(index, 1)
    }

    updateJoinParcelDropdown(addParcel: Boolean, index?: Number) {
        if(addParcel) {
            const totalParcels = this.billingLetter.parcels.length;
            const lastParcel = this.billingLetter.parcels[this.billingLetter.parcels.length-1];
            this.joinParcelsDropdown.list.push({
                id: String(totalParcels - 1),
                itemName: `Parcela #${totalParcels}`,
                parcelId: lastParcel._id,
                status: lastParcel.status
            });
            return;
        }

        let joinParcelIndexRemove, parcelIndexRemove;
        this.joinParcels = this.joinParcels.map((joinParcel, i) => {
            for(let parcelIndex in joinParcel.parcels) {
                if(Number(joinParcel.parcels[parcelIndex].id) == index) {
                    joinParcelIndexRemove = i;
                    parcelIndexRemove = parcelIndex;
                } else if(Number(joinParcel.parcels[parcelIndex].id) > index) {
                    joinParcel.parcels[parcelIndex] = {
                        id: String(Number(joinParcel.parcels[parcelIndex].id) - 1),
                        itemName: `Parcela #${joinParcel.parcels[parcelIndex].id}`
                    }
                }
            }
            return joinParcel;
        });

        if(joinParcelIndexRemove >= 0 && parcelIndexRemove >= 0)
            this.joinParcels[joinParcelIndexRemove].parcels.splice(parcelIndexRemove, 1);

        this.joinParcelsDropdown.list = [];
        this.billingLetter.parcels.forEach((parcel, parcelIndex) => {
            if(!parcel.parcelJoin)
                this.joinParcelsDropdown.list.push({
                    id: String(parcelIndex),
                    itemName: `Parcela #${parcelIndex + 1}`,
                    parcelId: parcel._id,
                    status: parcel.status
                });
        });
    }

    onJoinParcelSelect(item: any, joinParcelName){
        const index = this.joinParcelsDropdown.list.findIndex(it => it.id == item.id);
        this.joinParcelsDropdown.list.splice(index, 1);
        const parcelIndex = this.billingLetter.parcels.findIndex(parcel => parcel._id == item.parcelId);
        this.billingLetter.parcels[parcelIndex].parcelJoin = joinParcelName;
    }

    onJoinParcelUnselect(item: any){
        this.joinParcelsDropdown.list.push(item);
        this.joinParcelsDropdown.list.sort((a, b) => a.id - b.id);
        const parcelIndex = this.billingLetter.parcels.findIndex(parcel => parcel._id == item.parcelId);
        this.billingLetter.parcels[parcelIndex].parcelJoin = '';
    }

    changeJoinParcelName(index) {
        const newJoinParcelName = this.joinParcels[index].name;
        const parcels = this.joinParcels[index].parcels;
        for(let parcel of parcels) {
            this.billingLetter.parcels[Number(parcel.id)].parcelJoin = newJoinParcelName;
        }
    }

    joinParcelConfiguration(options: any, blockJoinParcel: boolean) {
        return {
            ...options,
            disabled: blockJoinParcel
        }
    }

    getIndustry(parcel){
        return parcel && parcel.company && parcel.company.industry ?
            parcel.company.industry : null
    }

    openMultipleParcelsModal(): void {
        if(!(this.billingLetter.companyGroup && this.billingLetter.companyGroup._id)) {
            this.toastr.warning('É necessario adicionar um grupo de empresa');
            return
        }

        let endParcel = this.billingLetter.parcels[this.billingLetter.parcels.length - 1];
        this.parcelIdModal = `${endParcel._id.toString()}-${new Date().getTime()}`;
        this.indexParcelModal = this.billingLetter.parcels.length;
        this.isCreate = true;
        this.isRecurrence = true;
        this.recurrence = 1;
        this.multiParcels = true;
        this.buttonOpenModalParcel.nativeElement.click();
        this.modalOpen = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/billing-letter/billing-letter-edit/billing-letter-edit.component.ts